import ArticleLayout from '@/components/feature/ArticleLayout';
import { sugargooReview } from '@/utils/articleContent';

export default function SugargooReviewPage() {
  return <ArticleLayout article={sugargooReview} />;
}